import { Bot, TerminalSquare } from 'lucide-react'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'
import type { AgentHarness } from '@/frontend/pages/Dashboard/DigitalWorkers/new/types'

const OPTIONS: Array<{
  value: AgentHarness
  label: string
  description: string
  icon: typeof Bot
}> = [
  {
    value: 'openclaw',
    label: 'OpenClaw',
    description: 'Runtime atual, com todos os canais existentes.',
    icon: Bot,
  },
  {
    value: 'codex',
    label: 'Codex',
    description: 'Codex no chat da Workstation e no Slack, após conectar o app do agente.',
    icon: TerminalSquare,
  },
]

export default function HarnessSelector({
  value,
  available,
  disabled,
  onChange,
}: {
  value: AgentHarness
  available: AgentHarness[]
  disabled: boolean
  onChange: (value: AgentHarness) => void
}) {
  return (
    <div className="grid gap-2">
      <Label>Harness do agente</Label>
      <div className="grid gap-3 sm:grid-cols-2">
        {OPTIONS.filter((option) => available.includes(option.value)).map((option) => {
          const Icon = option.icon
          const selected = option.value === value
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={selected}
              data-harness={option.value}
              disabled={disabled}
              onClick={() => onChange(option.value)}
              className={cn(
                'flex items-start gap-3 rounded-xl border p-4 text-left transition-colors',
                selected ? 'border-violet-500 bg-violet-500/5 ring-2 ring-violet-500/20' : 'border-border hover:border-violet-400/60',
                disabled && 'cursor-not-allowed opacity-60',
              )}
            >
              <Icon className="mt-0.5 h-4 w-4 shrink-0" />
              <span>
                <span className="block text-sm font-medium">{option.label}</span>
                <span className="mt-1 block text-xs text-muted-foreground">{option.description}</span>
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
